export enum FirestoreCollections {
  Projects = 'projects',
}
